import { render, staticRenderFns } from "./AgentListElement.vue?vue&type=template&id=d127d9e2&"
import script from "./agent-list-element?vue&type=script&lang=ts&"
export * from "./agent-list-element?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports